
import { createBrowserRouter } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import { AdminProtectedRoute } from "@/components/auth/AdminProtectedRoute";
import Login from "@/pages/Login";
import Index from "@/pages/Index";
import Dashboard from "@/pages/Dashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import Support from "@/pages/Support";
import Settings from "@/pages/Settings";
import WhatsApp from "@/pages/WhatsApp";
import CloseCRM from "@/pages/CloseCRM";
import NotFound from "@/pages/NotFound";
import Tutorials from "@/pages/Tutorials";
import MetaAuth from "@/pages/MetaAuth";
import Register from "@/pages/Register";
import InvitePage from "@/pages/InvitePage";
import SetPassword from "@/pages/SetPassword";
import CustomerData from "@/pages/admin/CustomerData";
import System from "@/pages/admin/System";
import Notifications from "@/pages/admin/Notifications";
import Logout from "@/pages/Logout";
import Partner from "@/pages/Partner";
import Roadmap from "@/pages/Roadmap";
import Home from "@/pages/Home";
import EmailServiceTest from "@/pages/EmailServiceTest";
import AdminLogin from "@/pages/AdminLogin";
import Registration from "@/pages/Registration";

const appRoutes = createBrowserRouter([
  // Public routes
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/admin-login",
    element: <AdminLogin />,
  },
  {
    path: "/register",
    element: <Register />,
  },
  {
    path: "/registration",
    element: <Registration />,
  },
  {
    path: "/logout",
    element: <Logout />,
  },
  {
    path: "/meta-auth",
    element: <MetaAuth />,
  },
  {
    path: "/set-password",
    element: <SetPassword />,
  },
  {
    path: "/invite",
    element: <InvitePage />,
  },
  
  // Protected routes
  {
    path: "/index",
    element: <ProtectedRoute><Index /></ProtectedRoute>,
  },
  {
    path: "/dashboard",
    element: <ProtectedRoute><Dashboard /></ProtectedRoute>,
  },
  {
    path: "/whatsapp",
    element: <ProtectedRoute><WhatsApp /></ProtectedRoute>,
  },
  {
    path: "/crm",
    element: <ProtectedRoute><CloseCRM /></ProtectedRoute>,
  },
  {
    path: "/support",
    element: <ProtectedRoute><Support /></ProtectedRoute>,
  },
  {
    path: "/tutorials",
    element: <ProtectedRoute><Tutorials /></ProtectedRoute>,
  },
  {
    path: "/settings",
    element: <ProtectedRoute><Settings /></ProtectedRoute>,
  },
  {
    path: "/partner",
    element: <ProtectedRoute><Partner /></ProtectedRoute>,
  },
  {
    path: "/roadmap",
    element: <ProtectedRoute><Roadmap /></ProtectedRoute>,
  },
  
  // Admin only routes
  {
    path: "/admin",
    element: <AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>,
  },
  {
    path: "/admin/dashboard",
    element: <AdminProtectedRoute><AdminDashboard /></AdminProtectedRoute>,
  },
  {
    path: "/admin/customers",
    element: <AdminProtectedRoute><CustomerData /></AdminProtectedRoute>,
  },
  {
    path: "/admin/system",
    element: <AdminProtectedRoute><System /></AdminProtectedRoute>,
  },
  {
    path: "/admin/notifications",
    element: <AdminProtectedRoute><Notifications /></AdminProtectedRoute>,
  },
  
  // Test routes
  {
    path: "/email-test",
    element: <EmailServiceTest />,
  },
  
  // 404 route
  {
    path: "*",
    element: <NotFound />,
  },
]);

export default appRoutes;
